export default __webpack_public_path__ + "static/media/bk-retur-jual.ac0744ac.png";